/* Fun Cases wishlist — no app, no backend.
   Stored client-side in localStorage (key fc_wishlist) as an array of product
   objects, the same lightweight approach used on Gieves & Hawkes. Works logged
   in or out; when logged in we identify the Klaviyo profile so the
   "Added to Wishlist" event ties to their email for marketing. */
(function () {
  var cfg = window.wishlistConfig || {};
  var KEY = 'fc_wishlist';

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function has(list, handle) { return list.some(function (x) { return x.handle === handle; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stripTags(s) { return String(s == null ? '' : s).replace(/<[^>]*>/g, ''); }

  /* ---------- Klaviyo ----------
     Primary: Client Events API (POST direct to Klaviyo with the PUBLIC company id
     — reliable, works for logged-in shoppers by email). Fallback: the onsite
     object queue (covers anonymous visitors via the Klaviyo cookie). */
  function klKey() { return cfg.klaviyoKey || (window.klaviyo && window.klaviyo.account) || null; }
  function kl(method, args) {
    try {
      var k = window.klaviyo;
      if (k && typeof k[method] === 'function') { k[method].apply(k, args); return; }
      if (k && typeof k.push === 'function') { k.push([method].concat(args)); return; }
      (window._learnq = window._learnq || []).push([method].concat(args));
    } catch (e) {}
  }
  function klIdentify(email) { if (email) kl('identify', [{ $email: email }]); }
  function klClientEvent(name, props, email) {
    var key = klKey();
    if (!key || !email) return false;
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        keepalive: true,
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: name } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        } } })
      });
      return true;
    } catch (e) { return false; }
  }
  function klAdd(d) {
    var props = {
      ProductName: d.title, Handle: d.handle, ProductID: d.id,
      URL: d.url ? (location.origin + d.url) : null, ImageURL: d.image, Price: stripTags(d.price)
    };
    // Reliable path first; only fall back to the onsite queue if we couldn't send it (anonymous / no key).
    if (klClientEvent('Added to Wishlist', props, cfg.email)) return;
    kl('track', ['Added to Wishlist', props]);
  }

  /* ---------- Buttons ---------- */
  function readData(btn) {
    return {
      handle: btn.getAttribute('data-product-handle'),
      id: btn.getAttribute('data-product-id'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: stripTags(btn.getAttribute('data-product-price'))
    };
  }
  function setBtn(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }
  function syncAll() {
    var list = load();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      setBtn(b, has(list, b.getAttribute('data-product-handle')));
    });
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'wl-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-shown');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('is-shown'); }, 2400);
  }

  /* ---------- Toggle ---------- */
  function toggle(btn) {
    var d = readData(btn);
    if (!d.handle) return;
    var list = load();
    if (has(list, d.handle)) {
      list = list.filter(function (x) { return x.handle !== d.handle; });
      save(list);
      setBtn(btn, false);
      if (btn.hasAttribute('data-wishlist-remove')) { var card = btn.closest('[data-wl-item]'); if (card) card.remove(); }
    } else {
      list.push({ handle: d.handle, id: d.id, title: d.title, url: d.url, image: d.image, price: d.price });
      save(list);
      setBtn(btn, true);
      klAdd(d);
      toast('Saved to your wishlist 💜');
    }
    syncAll();
    renderPage();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    toggle(b);
  });

  /* ---------- Wishlist page (rendered client-side from localStorage) ---------- */
  function renderPage() {
    var grid = document.querySelector('[data-wl-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wl-empty]');
    var list = load();
    if (!list.length) {
      grid.innerHTML = ''; grid.hidden = true;
      if (empty) empty.hidden = false;
      var sec = document.querySelector('[data-wl-recs-sec]'); if (sec) sec.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = list.map(function (p) {
      var img = p.image ? ('<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">') : '';
      return '<div class="wl-item" data-wl-item>' +
        '<a class="wl-item__media" href="' + esc(p.url) + '">' + img +
          '<button type="button" class="wl-item__remove is-active" data-wishlist-toggle data-wishlist-remove' +
            ' data-product-handle="' + esc(p.handle) + '" data-product-id="' + esc(p.id || '') + '"' +
            ' data-product-title="' + esc(p.title) + '" data-product-url="' + esc(p.url) + '"' +
            ' data-product-image="' + esc(p.image || '') + '" data-product-price="' + esc(p.price || '') + '"' +
            ' aria-label="Remove from wishlist" title="Remove from wishlist" aria-pressed="true">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 8.9A4.4 4.4 0 0 1 12 6.9a4.4 4.4 0 0 1 8.5 2A11.6 11.6 0 0 1 12 20.5Z"/></svg>' +
          '</button>' +
        '</a>' +
        '<div class="wl-item__info">' +
          '<a class="wl-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          (p.price ? '<div class="wl-item__price">' + esc(stripTags(p.price)) + '</div>' : '') +
          '<a class="btn btn-sun wl-item__cta" href="' + esc(p.url) + '">View product &rarr;</a>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* ---------- Recommendations (Shopify Product Recommendations API) ---------- */
  function money(cents) {
    var cur = cfg.currency || 'GBP';
    var n = (cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); }
    catch (e) { return '£' + n.toFixed(2); }
  }
  function renderRecs() {
    var sec = document.querySelector('[data-wl-recs-sec]');
    var wrap = document.querySelector('[data-wl-recs]');
    if (!sec || !wrap) return;
    var list = load();
    var seed = list[list.length - 1];
    if (!seed || !seed.id) { sec.hidden = true; return; }
    var have = {}; list.forEach(function (x) { have[x.handle] = 1; });
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(seed.id) + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) { sec.hidden = true; return; }
        var recs = j.products.filter(function (p) { return !have[p.handle]; }).slice(0, 8);
        if (!recs.length) { sec.hidden = true; return; }
        wrap.innerHTML = recs.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var cents = (typeof p.price === 'string') ? Math.round(parseFloat(p.price) * 100) : p.price;
          return '<a class="prod-card" href="' + esc(p.url) + '">' +
            '<div class="prod-media"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy"></div>' +
            '<div class="prod-info"><h3>' + esc(p.title) + '</h3><div class="prod-foot"><span class="price">' + esc(money(cents)) + '</span></div></div>' +
          '</a>';
        }).join('');
        sec.hidden = false;
      })
      .catch(function () { sec.hidden = true; });
  }

  /* ---------- Boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    syncAll();
    if (cfg.loggedIn) klIdentify(cfg.email);
    renderPage();
    renderRecs();
  });
  // Keep hearts + page in sync if changed in another tab.
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncAll(); renderPage(); } });
})();
